function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["alignItems", "justifyContent", "wrap", "direction", "flex", "className", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledFlex from './flex.styles';
import { StyledCacheWrapper } from './../../styles';
var alignItemProps = function alignItemProps() {
  return ['top', 'bottom', 'middle', 'stretch', 'baseline'];
};
var justifyContentProps = function justifyContentProps() {
  return ['center', 'start', 'end', 'between', 'around', 'stretch'];
};
var directionProps = function directionProps() {
  return ['row', 'row-reverse', 'column', 'column-reverse'];
};
var wrapProps = function wrapProps() {
  return ['wrap', 'wrap-reverse', 'nowrap'];
};
var flexProps = function flexProps() {
  return ['none', 'auto'];
};
var propTypes = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Add Flex items */
  children: PropTypes.node,
  /** Flex align vertical content: `'top', 'bottom', 'middle', 'stretch', 'baseline'` */
  alignItems: PropTypes.oneOfType([PropTypes.oneOf(alignItemProps()), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(alignItemProps()), PropTypes.shape({
    sm: PropTypes.oneOf(alignItemProps()),
    md: PropTypes.oneOf(alignItemProps()),
    lg: PropTypes.oneOf(alignItemProps()),
    xl: PropTypes.oneOf(alignItemProps())
  })]))]),
  /**
   * Set to none or auto
   */
  flex: PropTypes.oneOfType([PropTypes.oneOf(flexProps()), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(flexProps()), PropTypes.shape({
    sm: PropTypes.oneOf(flexProps()),
    md: PropTypes.oneOf(flexProps()),
    lg: PropTypes.oneOf(flexProps()),
    xl: PropTypes.oneOf(flexProps())
  })]))]),
  /** Flex align horizontal content: `'center', 'start', 'end', 'between', 'around', 'stretch'` */
  justifyContent: PropTypes.oneOfType([PropTypes.oneOf(justifyContentProps()), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(justifyContentProps()), PropTypes.shape({
    sm: PropTypes.oneOf(justifyContentProps()),
    md: PropTypes.oneOf(justifyContentProps()),
    lg: PropTypes.oneOf(justifyContentProps()),
    xl: PropTypes.oneOf(justifyContentProps())
  })]))]),
  /** Set to false for Inline Flex container */
  isBlock: PropTypes.bool,
  /** Flex direction:
   * `'row', 'row-reverse', 'column', 'column-reverse'`
   */
  direction: PropTypes.oneOfType([PropTypes.oneOf(directionProps()), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(directionProps()), PropTypes.shape({
    sm: PropTypes.oneOf(directionProps()),
    md: PropTypes.oneOf(directionProps()),
    lg: PropTypes.oneOf(directionProps()),
    xl: PropTypes.oneOf(directionProps())
  })]))]),
  /** Wrap flex items onto new line: `'wrap', 'wrap-reverse', 'nowrap'` */
  wrap: PropTypes.oneOfType([PropTypes.oneOf(wrapProps()), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(wrapProps()), PropTypes.shape({
    sm: PropTypes.oneOf(wrapProps()),
    md: PropTypes.oneOf(wrapProps()),
    lg: PropTypes.oneOf(wrapProps()),
    xl: PropTypes.oneOf(wrapProps())
  })]))]),
  /** Add utility object for child item flex props/other helpers like vertical/horizontal spacing */
  utils: PropTypes.object
};
var defaultProps = {
  className: '',
  children: /*#__PURE__*/React.createElement("p", null, "Add Flex Items"),
  alignItems: 'top',
  justifyContent: 'start',
  flex: 'auto',
  isBlock: true,
  direction: 'row',
  wrap: 'nowrap',
  utils: {}
};

/**
 * @ignore @description
 * ## Flex
 * Flex are containers that can contain controls and content inside them.
 *
 * @ignore @see Mesh: [Flex Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/scaffolding-flex--default)
 *
 * @ignore @example
 * ```jsx
 * import { Flex, Box } from 'mesh-component-library';
 *
 * <Flex>
 *  <Box type="warning" />
 *  <Box type="warning" />
 *  <Box type="warning" />
 * </Flex>;
 * ```
 */

var Flex = function Flex(props) {
  var alignItems = props.alignItems,
    justifyContent = props.justifyContent,
    wrap = props.wrap,
    direction = props.direction,
    flex = props.flex,
    className = props.className,
    children = props.children,
    other = _objectWithoutProperties(props, _excluded);
  var childrenWithProps = React.Children.map(children, function (child) {
    return child && child.props && child.props.utils ? /*#__PURE__*/React.cloneElement(child, {
      utils: _objectSpread({}, child.props.utils)
    }) : child;
  });
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledFlex, _extends({}, other, {
    className: className,
    alignItems: alignItems,
    justifyContent: justifyContent,
    flex: flex,
    direction: direction,
    wrap: wrap
  }), childrenWithProps));
};
Flex.propTypes = propTypes;
Flex.defaultProps = defaultProps;
export default Flex;